/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2024-04-24 16:51:33
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-05-06 21:01:19
 * @FilePath: /seller-station-client/src/common/layout/header/index.tsx
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import './siteHeader.css';
import { useState } from 'react';
import { useThrottle } from 'ahooks';
import { useNavigate } from 'react-router-dom';
import Logo from '@/common/icons/Logo';
import ExchangePopover from './components/exchangePopover/exchangePopover';
import SiteHeaderLogin from './components/siteHeaderLogin/siteHeaderLogin';
import { ShopCar } from './components/shopCart/shopCart';
import { SiteHeaderMask } from './components/siteHeaderMask/siteHeaderMask';

export const HEADER_HEIGHT = 60;

export default function () {
	const navigate = useNavigate();
	const tabs = [
		{
			title: 'Source',
			url: '/source'
		},
		{
			title: 'Membership',
			url: '/vip'
		}
	];

	const tabClick = (url: string) => {
		navigate(url);
	};
	const [maskVisible, setMaskVisible] = useState(false);
	const maskVisibleOnUse = useThrottle(maskVisible, {
		wait: 300,
		leading: false,
		trailing: true
	});
	return (
		<>
			<SiteHeaderMask {...{ maskVisibleOnUse }} />
			<div
				className={`w-full h-[60px] bg-black-950 flex justify-center sticky top-0 z-[999] h-[${HEADER_HEIGHT}px]`}
			>
				<div className="siteHeader">
					<Logo
						style={{ height: 28, width: 161 }}
						className="cursor-pointer"
						onClick={() => tabClick('/')}
					/>

					<div className="siteHeaderTabs">
						{tabs.map((v) => {
							return (
								<div
									onClick={() => tabClick(v.url)}
									key={v.title}
								>
									{v.title}
								</div>
							);
						})}
					</div>
					<div className="siteHeaderPanel flex">
						<ExchangePopover {...{ setMaskVisible }} />
						<SiteHeaderLogin {...{ setMaskVisible }} />
						<ShopCar />
					</div>
				</div>
			</div>
		</>
	);
}
